import { ObservableFromFetch } from "../ObservableFromFetch"
import KeyValue from "./Model/KeyValue"

export default function GetImplementationAliasFields() {
  return ObservableFromFetch<KeyValue[]>("FFOrderClinicFileMaintenance/GetImplementationAliasFields")
}